<div class="main-menu" *ngIf="dashboardIsReady">
  <!-- <iframe class="e2e-iframe-trusted-src" id="looker" [src]=goodUrl scrolling=“no” *ngIf="dashboardIsReady"></iframe> -->
  <app-power-bi [showSaveButtons]="false" [showReportName]="false" [passedInWorkspaceId]="workspaceId" [passedInReportId]="reportId1"></app-power-bi>
</div>
<div class="container" *ngIf="!dashboardIsReady">
    <div class="nav-container">
        <div class="logo">
            <h3>Flywheel Retail Insights Admin</h3>
        </div>

        <div class="links">
            <div>
                <a [routerLink]="['../', 'accounts']"
                    routerLinkActive="router-link-active" >
                    <button>
                        Login
                    </button>
                </a>
            </div>
        </div>
    </div>
</div>
